import { render, staticRenderFns } from "./walletList.vue?vue&type=template&id=43d93820&scoped=true&"
import script from "./walletList.vue?vue&type=script&lang=js&"
export * from "./walletList.vue?vue&type=script&lang=js&"
import style0 from "./walletList.vue?vue&type=style&index=0&id=43d93820&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d93820",
  null
  
)

export default component.exports